<template>
  <el-container>
    <el-main>
      <div style="margin: 50px 100px">
        <div>
          <h2 style="font-size: 30px; color: #617173;margin-top: 10px">
            《中醫行業現狀與未來：機遇與挑戰》
          </h2>
          <p style="font-size: 25px; color: #617173; margin-top: 10px">
            內容設計：
          </p>
          <p style="font-size: 20px; color: #617173;margin-top: 10px">
            行業全景分析：
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            邀請中醫藥管理局官員或資深行業分析師，解讀國內中醫政策（如「中醫藥振興發展」政策）、醫療體系中的中醫定位（社區中醫館、中西醫結合醫院等）。
          </p>
          <p style="font-size: 15px; color: #617173;">
            數據分享：中醫診療市場規模、就業需求熱門領域（如康復、治未病科）及人才缺口。
          </p>
          <p style="font-size: 20px; color: #617173; margin-top: 15px">
            挑戰探討：
          </p>
          <p style="font-size: 15px; color: #617173;">
            現代醫學衝擊下的中醫信任度問題（如循證醫學標準的爭議）。中醫藥國際化面臨的壁壘（海外法規、文化差異）。
          </p>
          <p style="font-size: 15px; color: #617173;">
            互動環節：分組討論「如何提升中醫在年輕群體中的認可度」，並由專家點評。
          </p>
          <p style="font-size: 20px; color: #617173;margin-top: 10px">
            效果：幫助學生全面認知行業生態，理性看待中醫發展的優勢與瓶頸。
          </p>
        </div>
        <el-divider style="width: 1200px;margin-left: 30px" />
        <div>
          <h2 style="font-size: 30px; color: #617173;margin-top: 10px">
            《現代科技與中醫的融合：從AI到生物技術》
          </h2>
          <p style="font-size: 25px; color: #617173; margin-top: 10px">
            內容設計：
          </p>
          <p style="font-size: 20px; color: #617173; margin-top: 10px">
            前沿技術案例分享：
          </p>
          <p style="font-size: 15px; color: #617173;">
            AI輔助舌診/脈診系統的開發與臨床應用。
          </p>
          <p style="font-size: 15px; color: #617173;">
            大數據分析在中藥複方研究中的作用（如網絡藥理學）。
          </p>
          <p style="font-size: 15px; color: #617173;">
            生物技術對中藥材品質控制（如DNA條形碼鑑定）的革新。
          </p>
          <p style="font-size: 20px; color: #617173; margin-top: 10px">
            跨界對話：
          </p>
          <p style="font-size: 15px; color: #617173;">
            邀請中醫專業背景的科技公司創始人，講述「中醫+科技」的創業歷程。
          </p>
          <p style="font-size: 20px; color: #617173; margin-top: 10px">
            實踐啟發：
          </p>
          <p style="font-size: 15px; color: #617173;">
            展示開放性科研平台（如中醫古籍數據庫），鼓勵學生參與跨學科研究。
          </p>
          <p style="font-size: 15px; color: #617173;">
            效果：打破「中醫傳統等於落後」的刻板印象，激發技術創新思維。
          </p>
        </div>
        <el-divider style="width: 1200px;margin-left: 30px" />
        <div>
          <h2 style="font-size: 30px; color: #617173;margin-top: 10px">
            《中醫國際化之路：海外實踐與文化傳播》
          </h2>
          <p style="font-size: 25px; color: #617173; margin-top: 10px">
            內容設計：
          </p>
          <p style="font-size: 20px; color: #617173;">
            全球視野拓展：
          </p>
          <p style="font-size: 15px; color: #617173;">
            中醫在「一帶一路」國家的推廣現狀（如中醫中心在非洲的運營模式）。
          </p>
          <p style="font-size: 15px; color: #617173;">
            歐美中醫從業者的生存實錄（如針灸在美國的保險覆蓋情況）。
          </p>
          <p style="font-size: 20px; color: #617173; margin-top: 10px">
            文化傳播策略：
          </p>
          <p style="font-size: 15px; color: #617173;">
            解析「中醫外交」案例（如新冠疫情中連花清瘟的國際關注）。
          </p>
          <p style="font-size: 15px; color: #617173;">
            如何用現代語言詮釋「陰陽五行」等理論（針對不同文化受眾）。
          </p>
          <p style="font-size: 20px; color: #617173; margin-top: 10px">
            職業可能性探討：
          </p>
          <p style="font-size: 15px; color: #617173;">
            國際中醫執業資格考證（如NCCAOM美國針灸師考試）備考攻略。
          </p>
          <p style="font-size: 15px; color: #617173;">
            效果：拓寬職業邊界，培養學生以全球化視角傳承中醫文化。
          </p>
        </div>
      </div>
    </el-main>
    <el-divider style="width: 1350px;margin-left: 30px" />
    <el-footer>
      <div>
        <div style="color: #617173; text-align:center; font-size: 10px;margin-bottom: 10px">
          華夏青年中醫協會
        </div>
        <div style="margin-left: 610px; margin-bottom: 20px">
          <img src="../assets/logo1.png" alt="Logo" style="width: 170px; height: auto">
        </div>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
export default {
name: "Activity2"
}
</script>

<style scoped>

</style>
